import { z } from 'zod';

import { LosId } from '../../BrandedIds';

export const ImportInvoiceRow = z.object({
  loanId: LosId,
  // TODO Just for WHEDA demo purposes, replace with actual fields
});

export type ImportInvoiceRow = z.infer<typeof ImportInvoiceRow>;
